(ns iris.scroll.restoration
  (:require
   [goog.functions :as gfn]))

(def scroll-state-key "scroll-top")
(defonce initialized? (atom false))

(defn scroll-top []
  (.-pageYOffset js/window))

(defn history-state []
  (.-state js/history))

(defn saved-scroll-top []
  (when-let [state (history-state)]
    (aget state scroll-state-key)))

(defn set-manual-scroll-restoration! []
  (when (some? (.-scrollRestoration js/history))
    (set! (.-scrollRestoration js/history) "manual")))

;; Pushy owns creating/replacing history entries for route changes. Scroll
;; restoration only annotates the current entry, so always copy existing
;; history.state before adding our scroll key.
(defn state-with-scroll-top [scroll-top]
  (let [state (or (history-state) #js {})]
    (doto (js/Object.assign #js {} state)
      (aset scroll-state-key scroll-top))))

(defn save-scroll-top! []
  (.replaceState js/history (state-with-scroll-top (scroll-top)) (.-title js/document)))

(defn event-target-element [e]
  (let [target (.-target e)]
    (cond
      (nil? target) nil
      (= 1 (.-nodeType target)) target
      (.-parentElement target) (.-parentElement target)
      :else nil)))

(defn closest-anchor [el]
  (when (and el (.-closest el))
    (.closest el "a[href]")))

(defn normal-primary-click? [e]
  (and (= 0 (or (.-button e) 0))
       (not (or (.-altKey e)
                (.-ctrlKey e)
                (.-metaKey e)
                (.-shiftKey e)))))

(defn same-origin-href? [href]
  (try
    (= (.-origin (js/URL. href (.. js/window -location -origin)))
       (.. js/window -location -origin))
    (catch :default _
      false)))

(defn save-before-navigation-click! [e]
  (when (normal-primary-click? e)
    (when-let [anchor-el (closest-anchor (event-target-element e))]
      (when-let [href (.getAttribute anchor-el "href")]
        (when (and (same-origin-href? href)
                   (not (.hasAttribute anchor-el "download"))
                   (not (#{"_blank" "_parent" "_top"} (.getAttribute anchor-el "target"))))
          (save-scroll-top!))))))

(defn initialize! []
  (when (compare-and-set! initialized? false true)
    (set-manual-scroll-restoration!)
    (.addEventListener
     js/window
     "click"
     save-before-navigation-click!
     #js {:capture true :passive true})
    (.addEventListener
     js/window
     "scroll"
     (gfn/debounce save-scroll-top! 200)
     #js {:passive true})))
